import { Box } from '@mui/material';
import { MuiFileUploader } from 'common/ui/file-uploader/MuiFileUploader';
import { FC, useState } from 'react';

interface IPublisherImageCreatorProps {
  onAdd: (file: File, preview: string) => void;
}

export const PublisherImageCreator: FC<IPublisherImageCreatorProps> = ({ onAdd }) => {
  const [value, setValue] = useState<File | null>(null);

  const handleChange = (file: File, preview: string) => {
    onAdd(file, preview);
    setValue(null);
  };

  return (
    <Box sx={{ '& > *': { borderRadius: '0 !important', border: 'none !important', height: '160px !important' } }}>
      <MuiFileUploader
        format={['image/jpeg', 'image/png', 'image/jpg', 'image/svg']}
        onChange={handleChange}
        value={value}
        withoutPreview
      />
    </Box>
  );
};
